import { all, fork } from 'redux-saga/effects'
import authSaga from './auth/sagas'
import personSaga from './person/sagas'
import companySaga from './company/sagas'
import documentsSaga from './documents/sagas'
import institutionsSaga from './institutions/sagas'
import vehiclesSaga from './vehicles/sagas'
import userSaga from './user/sagas'
import addressSaga from './address/sagas'
import contactsSaga from './contacts/sagas'
import layoutsSaga from './layout/sagas'
import relationshipsSaga from './relationships/sagas'

/**
 * <h5>The root sagas is a combination of all the functionality sagas.</p>
 * @see {@link https://redux-saga.js.org}
 * @see {@link https://redux-saga.js.org/docs/advanced/RootSaga/}
 * @typedef RootSagas
 * @namespace RootSagas
 * @category React
 * @subcategory Redux / Sagas
 */

/**
 * A root Saga aggregates multiple Sagas to a single entry point for the sagaMiddleware to run.
 * @memberof RootSagas
 * @alias RootSagas.rootSaga
 * @function
 * @category React
 * @subcategory Redux / Sagas
 * @returns {*}
 */
const rootSaga = function* () {
    yield all([
        fork(authSaga),
        fork(personSaga),
        fork(companySaga),
        fork(documentsSaga),
        fork(institutionsSaga),
        fork(vehiclesSaga),
        fork(userSaga),
        fork(addressSaga),
        fork(contactsSaga),
        fork(layoutsSaga),
        fork(relationshipsSaga)
    ])
}

export default rootSaga
